
/**
 * @typedef {object} ReturnsApi
 * @property {ReturnsApi__fetchOrder} fetchOrder
 * @property {ReturnsApi__createReturn} createReturn
 */

/**
 * @callback ReturnsApi__fetchOrder
 * @param orderNumber {string}
 * @param email {string}
 * @returns {Promise<import('./returns-api').TApiResult<import('./returns-api').TGetOrderResult>>}
 */

/**
 * @callback ReturnsApi__createReturn
 * @param returnData {import('./returns-api').TCreateReturnInput}
 * @returns {Promise<import('./returns-api').TApiResult<import('./returns-api').TCreateReturnResult>>}
 */

export default {
	install: ( app ) => {
		const { apiUrl } = window.returnsConfiguration.settings;

		/** @type ReturnsApi__fetchOrder **/
		const fetchOrder = async ( orderNumber, email ) => {
			const res = await fetch( `${ apiUrl }/order?orderNumber=${ orderNumber.trim() }&email=${ email.trim() }`, {
				method: 'GET',
			} );
			return res.json();
		};

		/** @type ReturnsApi__createReturn **/
		const createReturn = async ( returnData ) => {
			const res = await fetch( `${ apiUrl }/return`, {
				method: 'POST',
				body: JSON.stringify( returnData ).trim()
			} );
			return res.json();
		};

		/** @type ReturnsApi **/
		const returnsApi = {
			fetchOrder,
			createReturn,
			get mocked() { return mockedReturnsApi },
		};

		app.provide( 'returnsApi', returnsApi )
	}
}

const mockedFetchOrder = {
	"success": true,
	"data": {
		"orderId": "gid://shopify/Order/4819268829244",
		"returnableItems": [
			{
				"id": "gid://shopify/FulfillmentLineItem/10682385432636",
				"sku": "98422764-1-1",
				"name": "CALZE UOMO CENTURY - UNI",
				"imageSrc": "https://cdn.shopify.com/s/files/1/0559/3949/8044/products/984227642316-century_socks.jpg?v=1671839425"
			},
			{
				"id": "gid://shopify/FulfillmentLineItem/10682385432636",
				"sku": "98422764-1-1",
				"name": "CALZE UOMO CENTURY - UNI",
				"imageSrc": "https://cdn.shopify.com/s/files/1/0559/3949/8044/products/984227642316-century_socks.jpg?v=1671839425"
			},
			{
				"id": "gid://shopify/FulfillmentLineItem/10682385432636",
				"sku": "98422764-1-1",
				"name": "CALZE UOMO CENTURY - UNI",
				"imageSrc": "https://cdn.shopify.com/s/files/1/0559/3949/8044/products/984227642316-century_socks.jpg?v=1671839425"
			},
			{
				"id": "gid://shopify/FulfillmentLineItem/10682385399868",
				"sku": "98397421-51-1",
				"name": "CALZE UOMO ORIGINAL - UNI",
				"imageSrc": "https://cdn.shopify.com/s/files/1/0559/3949/8044/products/983974213643-calze__original.jpg?v=1671827904"
			},
			{
				"id": "gid://shopify/FulfillmentLineItem/10682385399868",
				"sku": "98397421-51-1",
				"name": "CALZE UOMO ORIGINAL - UNI",
				"imageSrc": "https://cdn.shopify.com/s/files/1/0559/3949/8044/products/983974213643-calze__original.jpg?v=1671827904"
			},
			{
				"id": "gid://shopify/FulfillmentLineItem/10682385367100",
				"sku": "98397421-87-1",
				"name": "CALZE UOMO ORIGINAL WHITE BLACK - UNI",
				"imageSrc": "https://cdn.shopify.com/s/files/1/0559/3949/8044/products/98397421-6788-calze__original.jpg?v=1671827943"
			},
			{
				"id": "gid://shopify/FulfillmentLineItem/10682385367100",
				"sku": "98397421-87-1",
				"name": "CALZE UOMO ORIGINAL WHITE BLACK - UNI",
				"imageSrc": "https://cdn.shopify.com/s/files/1/0559/3949/8044/products/98397421-6788-calze__original.jpg?v=1671827943"
			}
		],
		"hasBankDeposit": true
	}
};
const mockedCreateReturn = { success: true, data: { id: 'mocked', status: 'UNKNOWN' } };

/** @type ReturnsApi **/
const mockedReturnsApi = {
	fetchOrder: async () => mockedFetchOrder,
	createReturn: async () => mockedCreateReturn,
}
